import { createSelector } from 'reselect';

const selectCommunicationState = (state) => state.communicationsReducer;

export const getCommunicationToken = () => createSelector(
  selectCommunicationState,
  (state) => state.communicationToken
);
